import { useAppContext } from '../context/AppContext';

export function FirebaseProjectSelector() {
  const { firebaseProjectIds, firebaseProjectFilter, setFirebaseProjectFilter, projectsLoading } =
    useAppContext();

  return (
    <div>
      <div className="flex items-center justify-between mb-1.5">
        <span className="text-[10px] uppercase tracking-[0.12em] text-muted">
          Firebase Project
        </span>
        {firebaseProjectFilter && (
          <button
            type="button"
            onClick={() => setFirebaseProjectFilter(null)}
            className="text-[10px] text-muted hover:text-rose transition-colors"
          >
            Clear
          </button>
        )}
      </div>

      <div className="relative">
        <select
          className="appearance-none w-full bg-panel border border-panel-border text-white text-xs rounded-lg pl-3 pr-7 py-1.5 focus:outline-none focus:border-sage-mid cursor-pointer"
          value={firebaseProjectFilter || ''}
          onChange={(e) => setFirebaseProjectFilter(e.target.value || null)}
          disabled={projectsLoading}
        >
          <option value="">All Projects</option>
          {firebaseProjectIds.map((pid) => (
            <option key={pid} value={pid}>
              {pid}
            </option>
          ))}
        </select>
        <span className="pointer-events-none absolute right-2 top-1/2 -translate-y-1/2 text-muted text-[10px]">
          ▾
        </span>
      </div>

      {firebaseProjectFilter && (
        <div className="flex items-center gap-1.5 mt-1.5 px-0.5">
          <span className="w-1.5 h-1.5 rounded-full bg-sage-light flex-shrink-0" />
          <span className="text-[10px] font-mono text-sage-light/80 truncate">
            {firebaseProjectFilter}
          </span>
        </div>
      )}
    </div>
  );
}
